/* eslint-disable @typescript-eslint/no-unused-vars */
export const removeEmpty = (obj: Record<string, unknown>) =>
	Object.fromEntries(
		Object.entries(obj).filter(([_, v]) => v != null && v !== ''),
	);
